<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
    :key="$i18n.locale + '-fb'"
  >
    <template>
      <v-card :disabled="loading" flat>
        <v-expansion-panels v-model="expandedIndex" class="pa-2">
          <v-card-actions
            class="mb-4 justify-start d-flex row"
            style="width: 100%"
          >
            <v-btn :disabled="disablebtn" outlined @click="addDefaultQuestion">
              <v-icon left>mdi-plus</v-icon>
              {{ $t("restore_default_questions") }}
            </v-btn>
            <help-info
              v-if="!disablebtn"
              :element-name="`${serviceName}-${componentName}-question-addDefaultQuestion`"
              :help-data="helpData"
              :label="$t('restore_default_questions')"
              :service-name="serviceName"
              class="buttoninfo"
            />
            <v-btn
              v-if="disabledeletebtn"
              :enable="disabledeletebtn"
              color="error"
              outlined
              @click="deleteAllQuestions"
            >
              <v-icon left>mdi-delete</v-icon>
              {{ $t("delete_all") }}
            </v-btn>
            <help-info
              v-if="disabledeletebtn"
              :element-name="`${serviceName}-${componentName}-question-deleteAllQuestions`"
              :help-data="helpData"
              :label="$t('delete_all')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </v-card-actions>
          <v-expansion-panel
            v-for="(category, index) in computedValue.items"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header hide-actions>
              <div class="d-flex align-center" @click.stop="showDetails(index)">
                <div class="rowinfo" style="width: 100%">
                  <v-btn outlined @click.stop="openDialog(index)">
                    {{ $t("edit_question") }}:
                    {{
                      category.question ||
                      $t("question_number", { number: index + 1 })
                    }}
                    <v-icon right small>mdi-pencil</v-icon>
                  </v-btn>
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-category-title`"
                    :help-data="helpData"
                    :label="$t('edit_question')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
                <v-spacer />
                <v-btn
                  v-b-tooltip.hover.top="$t('move_up')"
                  :disabled="index === 0"
                  class="pa-0 ma-0"
                  icon
                  max-width="30"
                  right
                  x-small
                  @click.stop="moveUp(index)"
                >
                  <v-icon>mdi-chevron-up</v-icon>
                </v-btn>

                <v-btn
                  v-b-tooltip.hover.top="$t('delete')"
                  :title="$t('delete')"
                  icon
                  max-width="36"
                  right
                  x-small
                  @click.stop="deleteQuestion(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <help-info
                  v-if="index === -1"
                  :element-name="`${serviceName}-${componentName}-data-selectedBlog`"
                  :help-data="helpData"
                  :label="$t('selected_question')"
                  :service-name="serviceName"
                  class="buttoninfo"
                  right
                />
                <v-btn
                  v-b-tooltip.hover.top="$t('move_down')"
                  :disabled="index === computedValue.items.length - 1"
                  class="pa-0 ma-0"
                  icon
                  max-width="30"
                  right
                  x-small
                  @click.stop="moveDown(index)"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <p>
                  <strong>{{ $t("question") }}:</strong> {{ category.question }}
                </p>
                <p>
                  <strong>{{ $t("answer_type") }}:</strong>
                </p>
                <v-row no-gutters>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <div
                      v-if="
                        category.type === 'emoji' ||
                        (category.type === '' && computedValue.type === 'emoji')
                      "
                      class="border border-2 rounded p-3 d-flex clickable"
                    >
                      <h1 class="my-auto mx-auto">😢</h1>
                      <h1 class="my-auto mx-auto">😐</h1>
                      <h1 class="my-auto mx-auto">🙂</h1>
                    </div>
                  </v-col>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <div
                      v-if="
                        category.type === 'text' ||
                        (category.type === '' && computedValue.type === 'text')
                      "
                      class="border border-2 rounded py-4 p-3 d-flex"
                    >
                      <p class="my-auto mx-auto">{{ $t("excellent") }}</p>
                      <p class="my-auto mx-auto">{{ $t("good") }}</p>
                      <p class="my-auto mx-auto">{{ $t("very_poor") }}</p>
                    </div>
                  </v-col>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <div
                      v-if="
                        category.type === 'emoji_slider' ||
                        (category.type === '' &&
                          computedValue.type === 'emoji_slider')
                      "
                      class="border border-2 rounded p-3"
                    >
                      <v-slider
                        :thumb-size="0"
                        hide-details
                        thumb-label="always"
                      >
                        <template v-slot:thumb-label="{ value }">
                          <h1>
                            {{
                              satisfactionEmojis[
                                Math.min(Math.floor(value / 10), 9)
                              ]
                            }}
                          </h1>
                        </template>
                      </v-slider>
                    </div>
                  </v-col>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <div
                      v-if="
                        category.type === 'star' ||
                        (category.type === '' && computedValue.type === 'star')
                      "
                      class="border border-2 rounded p-3 d-flex"
                    >
                      <h1 class="my-auto mx-auto">⭐</h1>
                      <h1 class="my-auto mx-auto">⭐</h1>
                      <h1 class="my-auto mx-auto">⭐</h1>
                    </div>
                  </v-col>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <div
                      v-if="
                        category.type === 'thumbs' ||
                        (category.type === '' &&
                          computedValue.type === 'thumbs')
                      "
                      class="border border-2 rounded p-3 d-flex"
                    >
                      <h1 class="my-auto mx-auto">👍</h1>
                      <h1 class="my-auto mx-auto">👊</h1>
                      <h1 class="my-auto mx-auto">👎</h1>
                    </div>
                  </v-col>
                  <v-col class="pa-2" cols="12" md="4" sm="6">
                    <div
                      v-if="
                        category.type === 'slider' ||
                        (category.type === '' &&
                          computedValue.type === 'slider')
                      "
                      class="border border-2 rounded p-3"
                    >
                      <v-slider
                        :thumb-size="20"
                        hide-details
                        thumb-label="always"
                      />
                    </div>
                  </v-col>
                </v-row>
                <p>
                  <strong>{{ $t("response_optionality") }}:</strong>
                  {{
                    category.description
                      ? category.forceDesc
                        ? $t("required")
                        : $t("optional")
                      : $t("optional")
                  }}
                </p>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <feedback-question-picker
          v-if="dialog"
          v-model="dialog"
          :item.sync="editingItem"
          @editFeedBack="editFeedBack"
        />
        <v-card-actions class="mt-4">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              :loading="loading"
              class="contentinfo"
              color="success"
              outlined
              @click="submitFeedback"
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t("add_new_question") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-new-question`"
              :help-data="helpData"
              :label="$t('add_new_question')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FeedbackQuestionPicker from "@/view/components/pickers/feedbackQuestionPicker.vue";
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";

export default {
  name: "FeedBack",

  components: { FeedbackQuestionPicker },

  props: {
    info: {
      type: Object,
    },
    value: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
    },
    dialogs: {
      type: [Boolean],
      default: null,
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "FeedBack",
      disablebtn: true,
      disabledeletebtn: false,
      dialog: false,
      types: [
        { id: 1, type: "emoji" },
        { id: 2, type: "text" },
        { id: 3, type: "emoji_slider" },
        { id: 4, type: "star" },
        { id: 5, type: "thumbs" },
        { id: 6, type: "slider" },
      ],
      loading: false,
      expandedIndex: null,
      fab: null,
      tempObj: {
        question: "",
        type: "star",
        answer: "",
        value: null,
        description: true,
        forceDesc: false,
      },
      qIndex: null,
      initialDefaultItems: [
        {
          translationKey: "satisfied_with_quality",
          type: "emoji",
          answer: "",
          value: null,
          description: true,
          forceDesc: false,
        },
        {
          translationKey: "evaluate_packaging_quality",
          type: "emoji",
          answer: "",
          value: null,
          description: false,
          forceDesc: false,
        },
        {
          translationKey: "satisfied_with_variety",
          type: "emoji",
          answer: "",
          value: null,
          description: false,
          forceDesc: false,
        },
        {
          translationKey: "benefited_from_discounts",
          type: "emoji",
          answer: "",
          value: null,
          description: false,
          forceDesc: false,
        },
        {
          translationKey: "suggestions_for_improvement",
          type: "emoji",
          answer: "",
          value: null,
          description: true,
          forceDesc: true,
        },
      ],
      satisfactionEmojis: [
        "😭",
        "😢",
        "☹️",
        "🙁",
        "😐",
        "🙂",
        "😊",
        "😁",
        "😄",
        "😍",
      ],
      domainInfo: "",
      identifierInfo: "",
      qridInfo: "",
    };
  },

  mounted() {
    this.$root.$on("submitFeedback", this.submitFeedback);
    if (this.value?.items?.length > 0) {
      this.initialDefaultItems = [...this.value.items];
    }
    document.addEventListener("click", this.handleClickOutside);
    this.fetchAllFeedback();
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.updateTransition();
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal && typeof newVal === "object" && newVal.items?.length > 0) {
          this.computedValue = newVal;
          this.updateTransition();
        }
      },
    },
    computedValue: {
      deep: true,
      immediate: true,
      handler(newval) {
        this.disablebtn =
          !(newval.items.length === 0) && !this.hasMissingDefaultItems;
        this.disabledeletebtn = newval.items.length !== 0;
        this.$emit("input", newval);
      },
    },
    info: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this?.info) {
          this.domainInfo = val.domain.name;
          this.identifierInfo = val.identifier;
          this.qridInfo = val.id;
        }
      },
    },
    dialogs(val) {
      if (val) {
        this.fetchAllFeedback();
      } else {
        this.computedValue.items = [];
      }
    },
    "$i18n.locale": {
      handler() {
        this.initialDefaultItems = [];
        this.updateTransition();
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    ...mapState("local", ["identifier", "domain", "qrInfo"]),
    ...mapGetters("ribbon", ["user"]),

    hasMissingDefaultItems() {
      if (!this.initialDefaultItems) return false;
      return this.initialDefaultItems.some(
        (defaultItem) =>
          !this.computedValue.items.some(
            (item) => item.question === this.$t(defaultItem.translationKey),
          ),
      );
    },
    computedValue: {
      get() {
        return typeof this.value === "object" && this.value !== null
          ? this.value
          : { items: [] };
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    editingItem: {
      get() {
        return this.computedValue.items[this.qIndex];
      },
      set(val) {
        this.computedValue.items[this.qIndex] = val;
        this.qrUpdate();
      },
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  methods: {
    updateTransition() {
      if (
        !Array.isArray(this.initialDefaultItems) ||
        this.initialDefaultItems.length === 0
      ) {
        console.warn(
          "initialDefaultItems is not properly initialized:",
          this.initialDefaultItems,
        );
        this.initialDefaultItems = [
          {
            translationKey: "satisfied_with_quality",
            type: "emoji",
            answer: "",
            value: null,
            description: true,
            forceDesc: false,
          },
          {
            translationKey: "evaluate_packaging_quality",
            type: "emoji",
            answer: "",
            value: null,
            description: false,
            forceDesc: false,
          },
          {
            translationKey: "satisfied_with_variety",
            type: "emoji",
            answer: "",
            value: null,
            description: false,
            forceDesc: false,
          },
          {
            translationKey: "benefited_from_discounts",
            type: "emoji",
            answer: "",
            value: null,
            description: false,
            forceDesc: false,
          },
          {
            translationKey: "suggestions_for_improvement",
            type: "emoji",
            answer: "",
            value: null,
            description: true,
            forceDesc: true,
          },
        ];
      }

      this.initialDefaultItems = this.initialDefaultItems.map((item) => {
        if (item.translationKey) {
          return {
            ...item,
            question: this.$t(item.translationKey),
          };
        }
        return {
          ...item,
          question: item.question || "",
        };
      });
    },
    objectToFormData(obj, form = new FormData(), namespace = "") {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const formKey = namespace ? `${namespace}[${key}]` : key;
          const value = obj[key];

          if (value instanceof Date) {
            form.append(formKey, value.toISOString());
          } else if (value instanceof File) {
            form.append(formKey, value);
          } else if (typeof value === "object" && value !== null) {
            this.objectToFormData(value, form, formKey);
          } else {
            form.append(formKey, value);
          }
        }
      }
      return form;
    },

    toggleFab(index) {
      this.fab = this.fab === index ? null : index;
    },

    handleClickOutside(event) {
      const containers = this.$refs.buttonContainer;
      if (!containers) return;
      const container = Array.isArray(containers)
        ? containers[this.fab]
        : containers;
      if (this.fab !== null && container && !container.contains(event.target)) {
        this.fab = null;
      }
    },

    showDetails(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },

    openDialog(index) {
      this.qIndex = index;
      this.dialog = true;
    },

    moveUp(index) {
      let items = [...this.computedValue.items];
      [items[index - 1], items[index]] = [items[index], items[index - 1]];
      this.computedValue.items = items;
    },

    moveDown(index) {
      let items = [...this.computedValue.items];
      [items[index], items[index + 1]] = [items[index + 1], items[index]];
      this.computedValue.items = items;
    },

    async deleteQuestion(index) {
      if (await this.$modal.yesNo(this.$t("confirm_delete_question"))) {
        let item = this.computedValue.items[index];
        this.loading = true;
        if (item.id) {
          this.$api
            .delete("/v1/testQr/feedback/delete", { params: { id: item.id } })
            .then(() => {
              this.fetchAllFeedback();
              this.$toast.success(this.$t("question_deleted_success"));
            })
            .catch(({ response }) => {
              this.$toast.error(this.$t("question_delete_failed"));
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },

    async deleteAllQuestions() {
      if (await this.$modal.yesNo(this.$t("confirm_delete_all_questions"))) {
        let qr_id = this.createQrID;
        this.loading = true;
        this.$api
          .delete("/v1/testQr/feedback/destroyAll", { params: { qr_id } })
          .then(() => {
            // this.fetchAllFeedback();
            this.computedValue.items = [];
            this.$toast.success(this.$t("questions_deleted_success"));
          })
          .catch(({ response }) => {
            this.$toast.error(this.$t("questions_delete_failed"));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    addDefaultQuestion() {
      const currentItems = this.computedValue.items;
      let newItems = this.initialDefaultItems;
      if (currentItems.length !== 0) {
        newItems = this.initialDefaultItems.filter(
          (defaultItem) =>
            !currentItems.some(
              (item) => item.question === defaultItem.question,
            ),
        );
      }

      // if (newItems.length === 0) {
      //   this.$toast.info(this.$t("defaults_reset_success"));
      //   return;
      // }

      this.submitFeedbackDefaults(newItems);
    },

    submitFeedback(e = "submit") {
      this.loading = true;
      let qr_id = this.createQrID;
      if (e === "edit") {
        let arr = this.computedValue.items.map((i) => {
          let obj = {
            id: i.id,
            user_id: this.user.id,
            type_id: this.types?.find((t) => t.type == i.type).id,
            qr_id,
            question: i.question,
            has_description: i.description ?? 0,
            description_status: i.forceDesc ? "required" : "optional",
          };
          return obj;
        });
        return new Promise((resolve, reject) => {
          this.$api
            .post("/v1/testQr/feedback/questions", arr)
            .then((data) => {
              resolve("resolved");
              this.fetchAllFeedback();
            })
            .catch(({ response }) => {
              if (
                !!response?.data?.errors &&
                !!Object.keys(response.data.errors).length
              )
                this.$toast.error(this.$t("invalid_input"));
              else this.$toast.error(this.$t("operation_failed"));
              reject("rejected");
              this.loading = false;
            })
            .finally(() => {
              this.loading = false;
            });
        });
      } else {
        let arr = this.computedValue.items.map((i) => {
          let obj = {
            id: i.id,
            user_id: this.user.id,
            type_id: this.types.find((t) => t.type == i.type).id,
            qr_id,
            question: i.question,
            has_description: i.description ?? 0,
            description_status: i.forceDesc ? "required" : "optional",
            answer: "",
          };
          return obj;
        });

        arr.push({
          question: this.$t("question_number", {
            number: this.computedValue.items.length + 1,
          }),
          type_id: 2,
          qr_id,
          description_status: null,
          has_description: false,
          answer: "",
        });

        return new Promise((resolve, reject) => {
          this.$api
            .post("/v1/testQr/feedback/questions", arr)
            .then((data) => {
              resolve("resolved");
              this.fetchAllFeedback();
            })
            .catch(({ response }) => {
              if (
                !!response?.data?.errors &&
                !!Object.keys(response.data.errors).length
              )
                this.$toast.error(this.$t("invalid_input"));
              else this.$toast.error(this.$t("operation_failed"));
              reject("rejected");
              this.loading = false;
            })
            .finally(() => {
              this.loading = false;
            });
        });
      }
    },

    submitFeedbackDefaults(e) {
      try {
        this.loading = true;
        const qr_id = this.createQrID;

        const arr = e.map((i) => ({
          user_id: this.user.id,
          type_id: this.types.find((t) => t.type === i.type)?.id ?? 1,
          qr_id,
          question: i.question,
          has_description: i.description ?? false,
          description_status: i.forceDesc ? "required" : "optional",
          answer: i.answer ?? "",
        }));
        // if (arr.length === 0) {
        //   this.$toast.error(this.$t("no_valid_questions_to_submit"));
        //   this.loading = false;
        //   return;
        // }

        return new Promise((resolve, reject) => {
          this.$api
            .post("/v1/testQr/feedback/questions", arr)
            .then((response) => {
              this.$toast.success(this.$t("defaults_reset_success"));
              resolve("resolved");
              this.fetchAllFeedback();
            })
            .catch(({ response }) => {
              console.error("API Error:", response?.data || response);
              if (
                response?.data?.errors &&
                Object.keys(response.data.errors).length
              ) {
                this.$toast.error(this.$t("invalid_input"));
              } else {
                this.$toast.error(this.$t("operation_failed"));
              }
              reject("rejected");
            })
            .finally(() => {
              this.loading = false;
            });
        });
      } catch (error) {
        console.error("Unexpected Error in submitFeedbackDefaults:", error);
        this.$toast.error(this.$t("unexpected_error"));
      } finally {
        this.loading = false;
      }
    },

    fetchAllFeedback() {
      this.loading = true;
      let domain = !!this?.info
        ? this.domainInfo
        : this.domainName ?? this.qrInfo?.domain_id === 5
        ? "qrland.in/"
        : "";
      this.$api
        .get(`/v1/testQr/feedback/${domain}${this.identifier}`)
        .then(({ data }) => {
          const items = Array.isArray(data.data) ? data.data : [];
          this.computedValue.items = items.map((item) => ({
            id: item.id,
            question: item.question,
            type: this.types.find((type) => type.id == item.type_id).type,
            answer: item.answer,
            description: item.has_description,
            forceDesc: item.description_status === "required",
          }));
        })
        .catch(({ response }) => {})
        .finally(() => (this.loading = false));
    },

    editFeedBack(e) {
      if (e) {
        this.submitFeedback("edit");
      }
    },
  },
};
</script>

<style scoped>
.v-input >>> .v-input__append-outer {
  margin-top: 0 !important;
}

.mobile-buttons {
  position: relative;
  display: flex;
  align-items: center;
}

.mobile-activator {
  margin-left: 4px;
}

.button-list {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  z-index: 10;
  background: white;
  padding: 14px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: 100px;
}

.mobile-btn {
  margin: 0 !important;
  width: 36px !important;
  height: 36px !important;
}

.div-btn {
  justify-content: space-between;
  width: 100%;
  gap: 3px;
  align-items: center;
}
</style>
